import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Avatar,
    Menu,
    MenuItem,
} from "@mui/material";
import { useState, useContext } from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useTheme } from "@mui/material/styles";
import { ColorModeContext } from "../theme/themeContext";
import { AuthContext } from "../theme/AuthContext";

export default function Topbar({ onMenuToggle }) {
    const [langAnchor, setLangAnchor] = useState(null);
    const { user } = useContext(AuthContext)
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);

    const openLangMenu = (e) => setLangAnchor(e.currentTarget);
    const closeLangMenu = () => setLangAnchor(null);
    console.log(user.profilePic, "yeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                bgcolor: theme.palette.background.paper,     // ✔ dynamic background
                color: theme.palette.text.primary,           // ✔ dynamic text
                borderBottom: `1px solid ${theme.palette.divider}`, // ✔ dynamic border
                zIndex: (t) => t.zIndex.drawer + 1,
            }}
        >
            <Toolbar sx={{ display: "flex", alignItems: "center", p: 1 }}>

                {/* LEFT LOGO */}
                <Box sx={{ width: { xs: "90%", md: "16%" }, display: "flex", alignItems: "center" }}>
                    <img
                        src="/topperhub.png"
                        alt="cse"
                        style={{ height: "40px", width: "136px" }}
                    />
                </Box>

                {/* RIGHT SECTION */}
                <Box
                    sx={{
                        width: { xs: "10%", md: "84%" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    {/* Sidebar Toggle */}
                    <IconButton onClick={onMenuToggle}>
                        <svg width="18" height="18" viewBox="0 0 18 18">
                            <path
                                d="M3 3.75H12M3 9H15M3 14.25H9"
                                stroke={theme.palette.primary.main}   // ✔ adapts to theme
                                strokeWidth="1.125"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <Typography sx={{ ml: 1, display: { xs: "none", md: "block" } }}>
                            Dashboard
                        </Typography>
                    </IconButton>

                    {/* RIGHT ACTIONS */}
                    <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 3 }}>

                        {/* 🌙 Theme Toggle */}
                        <IconButton onClick={colorMode.toggleColorMode} color="inherit">
                            {theme.palette.mode === "dark" ? (
                                <Brightness7Icon />
                            ) : (
                                <Brightness4Icon />
                            )}
                        </IconButton>

                        {/* 🌐 Language */}
                        {/* <Box display="flex" alignItems="center" sx={{ cursor: "pointer" }} onClick={openLangMenu}>
                            <Typography fontSize={14} fontWeight={500}>English</Typography>
                            <ExpandMoreIcon fontSize="small" />
                        </Box> */}

                        {/* <Menu anchorEl={langAnchor} open={Boolean(langAnchor)} onClose={closeLangMenu}>
                            <MenuItem onClick={closeLangMenu}>English</MenuItem>
                            <MenuItem onClick={closeLangMenu}>Hindi</MenuItem>
                            <MenuItem onClick={closeLangMenu}>Punjabi</MenuItem>
                        </Menu> */}

                        {/* 🔔 Notifications */}
                        {/* <IconButton color="inherit">
                            <NotificationsNoneIcon />
                        </IconButton> */}

                        {/* 👤 Avatar */}
                        
                        <Box display="flex" alignItems="center" gap={1}>
                            <Avatar src={user?.profilePic || "/placeholder-profile.jpg"} />
                            <Typography fontSize={14} fontWeight={500}>{ user?.name || "User" }</Typography>
                        </Box>
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
